/* eslint-disable max-len */

export class CorrenteCadastroZCO {
    constructor(dependentes, parentesco, categorias,valoresForm,isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.quantidadeTotalDependentes = dependentes.length;
        this.arrayParentesco = ['ESPOSO(A)', 'PAI', 'MAE', 'GENRO', 'NORA', 'FILHO(A)', 'NETO(A)', 'ENTEADO(A)'];
    }

    possui8Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 8) {
            this.arrayMsgsErro.push('Este plano permite apenas 8 dependentes.');
        }

        return this;
    }

    dependentePet() {
        if (this.valoresForm.Parentesco.trim() === 'PET') {
            this.arrayMsgsErro.push('Este plano não permite dependentes com o parentesco PET.');
        }

        return this;
    }
}